export const API_BASE = process.env.REACT_APP_API_URL || 
  (typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
    ? "http://localhost:5012/"
    : (typeof window !== "undefined" ? window.location.origin + "/" : "/"));

export const getImageUrl = (path, fallback = "") => {
  if (!path) return fallback;
  let str = String(path).trim();
  if (str.startsWith("data:")) return str;

  // Strip localhost / 127.0.0.1 origins if present in stored path
  if (str.includes("localhost:") || str.includes("127.0.0.1:")) {
    str = str.replace(/^https?:\/\/[^/]+/, "");
  }

  // If it's a valid external URL (e.g. youtube, razorpay, external CDN), return as-is
  if (str.startsWith("http://") || str.startsWith("https://")) {
    if (str.startsWith("http://vaithikasri.com")) {
      str = str.replace("http://vaithikasri.com", "https://vaithikasri.com");
    }
    return encodeURI(str);
  }

  const cleanBase = API_BASE.endsWith("/") ? API_BASE : API_BASE + "/";
  const cleanPath = str.startsWith("/") ? str.slice(1) : str;

  return encodeURI(cleanBase + cleanPath);
};

// ================= HOME =================
export const API = API_BASE + "api";
export const HOME_UPLOAD_API = API_BASE + "api?action=upload";

// ================= ABOUT =================
export const ABOUT_API = API_BASE + "about_api";
export const ABOUT_UPLOAD_API = API_BASE + "upload_image";

//Publications
export const HOME_API = API_BASE + "api";
export const BOOKS_API = API_BASE + "books";

// Magazine
export const MAGAZINE_API = API_BASE + "magazine_api";

// ================= MY ACCOUNT (ADMIN) =================
export const ADMIN_ACCOUNT_API = API_BASE + "get_admin";
export const ADMIN_UPDATE_API = API_BASE + "update_admin";
export const ADMIN_DELETE_API = API_BASE + "delete_admin";

//AdminAuth
export const ADMIN_LOGIN_API = `${API_BASE}admin_login`;
export const ADMIN_REGISTER_API = `${API_BASE}admin_register`;

// Bookings
export const BOOKINGS_API = API_BASE + "bookings";

// Events
export const EVENTS_API = API_BASE + "eventApi";
export const EVENT_IMAGE_BASE = API_BASE + "uploads/";

//Guest Book
export const GUESTBOOK_API = API_BASE + "guestbook";

// Vedapatshala
export const COURSE_API = API_BASE + "api_course";
export const COURSE_UPLOAD_API = API_BASE + "upload_course";
export const GURUKULAM_API = API_BASE + "api_gurukulam";
export const VEDAPATSHALA_ENQUIRY_API = API_BASE + "vedapatshala_enquiry";
export const GURUKULAM_ADMISSIONS_API = API_BASE + "gurukulam_admissions";
export const DONATION_ENQUIRY_API = API_BASE + "donation_enquiries";
export const GURUKULAM_DONATION_ENQUIRY_API = API_BASE + "gurukulam_donation_enquiry";
export const DONATIONS_API = API_BASE + "api/donations";
export const SITE_SETTINGS_API = API_BASE + "site_settings";
export const VIVAHAPRAPTHI_API = API_BASE + "vivahaprapthi";

// ================= GALLERY =================
export const GALLERY_API = API_BASE + "gallery";


// Orders
export const ORDERS_API = `${API_BASE}orders`;
export const SHIPPING_CHARGES_API = `${API_BASE}shipping_charges`;

// Razorpay
export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY || "";

//Links
export const LINKS_API = `${API_BASE}links`;

//Subscription
export const PLANS_API = `${API_BASE}plans`;

// USERS
export const USERS_API = `${API_BASE}getUsers`;
export const DELETE_USER_API = `${API_BASE}deleteUser`;
export const EDIT_USER_API = `${API_BASE}editUser`;
export const SUBSCRIBERS_API = `${API_BASE}getSubscriptions`;
export const DOWNLOAD_TEMPLATE_API = `${SUBSCRIBERS_API}/download_template`;
export const IMPORT_SUBSCRIBERS_API = `${SUBSCRIBERS_API}/import`;
export const EXPORT_SUBSCRIBERS_API = `${SUBSCRIBERS_API}/export`;
export const PAYMENT_API = `${API_BASE}payment`;

// Matrimonial
export const MATRIMONIAL_ENQUIRY_API = `${API_BASE}matrimonial_enquiry`;

// Bulk Discount
export const BULK_DISCOUNT_API = `${API_BASE}bulk_discount`;

// WhatsApp Interakt API
export const WHATSAPP_API = `${API_BASE}whatsapp`;

// Blog
export const BLOG_API = (typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"))
  ? `${API_BASE}blog`
  : `${API_BASE}api/blog`;
